module.exports = __webpack_public_path__ + "static/microsoft-certified-azure-data-fundamentals-15a1c3fd1dec92efeaba2f778e2618af.png";